import { render, staticRenderFns } from "./ForgotPasswordUser.vue?vue&type=template&id=62d7f045&scoped=true"
import script from "./ForgotPasswordUser.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7f045",
  null
  
)

export default component.exports